const DEFAULT_SOLD_LISTING_VISIBILITY_DAYS = 5;

const getVisibilityDays = () => {
  const configuredDays = Number.parseInt(process.env.REACT_APP_SOLD_LISTING_VISIBILITY_DAYS, 10);
  return Number.isInteger(configuredDays) && configuredDays > 0
    ? configuredDays
    : DEFAULT_SOLD_LISTING_VISIBILITY_DAYS;
};

export const SOLD_LISTING_VISIBILITY_DAYS = getVisibilityDays();

export const isListingSold = listing => {
  const publicData = listing?.attributes?.publicData || {};
  const sold = publicData.sold;
  return sold === true || sold === 'true' || publicData.isSold === true;
};

export const isListingSoldOrOutOfStock = listing => {
  const currentStock = listing?.currentStock?.attributes?.quantity;
  return isListingSold(listing) || currentStock === 0;
};

export const getSoldAtDate = listing => {
  const soldAt = listing?.attributes?.publicData?.soldAt;
  const date = soldAt ? new Date(soldAt) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};

export const isSoldListingVisible = listing => {
  if (!isListingSold(listing)) {
    return true;
  }

  const soldAt = getSoldAtDate(listing);
  if (!soldAt) {
    return true;
  }

  const visibleUntil = soldAt.getTime() + SOLD_LISTING_VISIBILITY_DAYS * 24 * 60 * 60 * 1000;
  return visibleUntil > Date.now();
};

export const getSoldPublicData = (publicData = {}, options = {}) => {
  const { soldAt = new Date().toISOString(), soldManually = false } = options;
  return {
    ...publicData,
    sold: true,
    isSold: true,
    soldAt,
    ...(soldManually ? { soldManually: true } : {}),
  };
};
